import { useEffect, useState, useCallback } from "react";
import { runSyncPass, counts } from "../lib/opQueue";

/**
 * P-6: Operation-Queue Worker + Counts-Subscription.
 * - Startet bei Mount, läuft alle 30 s + auf `online`.
 * - Liefert Counts für Header-Badge.
 */
export function useOpQueueWorker() {
    const [c, setC] = useState({ active: 0, failed: 0, conflict: 0, unresolved: 0 });

    const refresh = useCallback(async () => {
        try {
            setC(await counts());
        } catch (_e) { /* ignore */ }
    }, []);

    useEffect(() => {
        let cancelled = false;
        const pass = async () => {
            if (cancelled) return;
            try {
                await runSyncPass();
            } catch (_e) { /* ignore */ }
            refresh();
        };
        pass();
        const iv = setInterval(pass, 30_000);
        const onOnline = () => pass();
        const onVisible = () => {
            if (document.visibilityState === "visible") pass();
        };
        window.addEventListener("online", onOnline);
        document.addEventListener("visibilitychange", onVisible);
        const poll = setInterval(refresh, 3000); // UI-refresh
        return () => {
            cancelled = true;
            clearInterval(iv);
            clearInterval(poll);
            window.removeEventListener("online", onOnline);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [refresh]);

    return { counts: c, refresh };
}
